function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M42.611,55a.629.629,0,0,0,.314-.084l8.982-5.186a.629.629,0,0,0,.314-.545V38.815a.629.629,0,0,0-.314-.544l-8.982-5.186a.629.629,0,0,0-.629,0L33.314,38.27a.629.629,0,0,0-.314.544V49.186a.629.629,0,0,0,.314.545L42.3,54.916A.629.629,0,0,0,42.611,55Zm8.353-6.177-7.724,4.46v-8.92l7.724-4.46Zm-.629-10.009-7.724,4.459-3.321-1.918L47.013,36.9Zm-7.724-4.459,3.145,1.816L38.032,40.63l-3.145-1.816Zm-.629,18.928-7.724-4.46V39.9l7.724,4.459Z",
  transform: "translate(-33 -33)",
  fill: "#fff"
});

var SvgBag = function SvgBag(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 19.221,
    height: 22,
    viewBox: "0 0 19.221 22",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgBag, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bag.6c22c3b9.svg";
export { ForwardRef as ReactComponent };